<template>
  <header class="page-header" :class="{ 'page-header--tall': tall }">
    <v-icon v-if="icon" class="page-header__mark" aria-hidden="true">{{ icon }}</v-icon>
    <div class="page-header__row">
      <div class="page-header__text">
        <h1 class="page-header__title">{{ title }}</h1>
        <p v-if="subtitle || $slots.subtitle" class="page-header__subtitle">
          <slot name="subtitle">{{ subtitle }}</slot>
        </p>
      </div>
      <div v-if="$slots.actions" class="page-header__actions">
        <slot name="actions" />
      </div>
    </div>
    <div v-if="$slots.default" class="page-header__extra">
      <slot />
    </div>
  </header>
</template>

<script>
// The dark band at the top of every page: title, one line of context, the page's main action.
// The page body (.page-body) overlaps its lower edge.
export default {
  name: "PageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "" },
    tall: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.page-header {
  position: relative;
  overflow: hidden;
  background: var(--pine-900);
  color: #fff;
  padding: 6px var(--gutter) 104px;
}
.page-header--tall {
  padding-bottom: 128px;
}
.page-header__mark.v-icon {
  position: absolute;
  right: -28px;
  top: -46px;
  font-size: 250px;
  color: var(--leaf);
  opacity: 0.05;
  pointer-events: none;
}
.page-header__row {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px 24px;
}
.page-header__text {
  min-width: 0;
  max-width: 820px;
}
.page-header__title {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(2rem, 3.4vw, 2.9rem);
  line-height: 1.04;
  letter-spacing: -0.025em;
  margin: 0;
  color: #fff;
}
.page-header__subtitle {
  margin: 10px 0 0;
  font-size: 1.08rem;
  line-height: 1.45;
  color: var(--leaf-200);
}
.page-header__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.page-header__extra {
  position: relative;
  margin-top: 22px;
}
html.density-compact .page-header {
  padding-bottom: 78px;
}
html.density-compact .page-header--tall {
  padding-bottom: 96px;
}
html.density-compact .page-header__title {
  font-size: clamp(1.6rem, 2.4vw, 2.1rem);
}
html.density-compact .page-header__subtitle {
  margin-top: 4px;
  font-size: 1rem;
}
html.density-compact .page-header__extra {
  margin-top: 14px;
}
@media (max-width: 600px) {
  .page-header {
    padding-bottom: 96px;
  }
  html.density-compact .page-header {
    padding-bottom: 72px;
  }
  .page-header__mark.v-icon {
    font-size: 150px;
  }
}
</style>
